<template>
  <div class="flex right_card">
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.buyCardList.1')}}</div>
      <div class="card_content font_bold">
        <span>{{millionFormat(investmentSummary.totalInvestmentVolume)}}</span>
        <i v-if="isMillion(investmentSummary.totalInvestmentVolume)">m</i>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.buyCardList.3')}}</div>
      <div class="card_content font_bold">
        <span>{{millionFormat(investmentSummary.outstandingVolume) }}</span>
        <i v-if="isMillion(investmentSummary.outstandingVolume)">m</i>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.buyCardList.4')}}</div>
      <div class="card_content font_bold">
        <FieldWithUnit :value="investmentSummary.avgExpectedRoi" unit="%"></FieldWithUnit>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.buyCardList.5')}}</div>
      <div class="card_content font_bold">
        <FieldWithUnit :value="investmentSummary.avgEffectiveRoi" unit="%"></FieldWithUnit>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.buyCardList.6')}}</div>
      <div class="card_content font_bold">
        <FieldWithUnit :value="investmentSummary.durationDays" :unit="$t('common.day.short')"></FieldWithUnit>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {formatAsDecimal} from "@/common/format";
import FieldWithUnit from "@/views/dashboard/FieldWithUnit";

export default {
  data() {
    return {
      defaultInvestmentSummary: {
        totalInvestmentVolume: "",
        outstandingVolume: "",
        avgExpectedRoi: null,
        avgEffectiveRoi: null,
        durationDays: null
      },
      investmentSummary: {
        ...this.defaultInvestmentSummary
      }
    };
  },
  components: {
    FieldWithUnit
  },
  computed: {
    ...mapGetters({ dashboardInfo: "dashboardInfo" })
  },
  watch: {
    dashboardInfo() {
      let { statisticData } = this.dashboardInfo;
      if (statisticData && statisticData.investmentSummary) {
        this.investmentSummary = {
          ...statisticData.investmentSummary,
          avgExpectedRoi: formatAsDecimal(statisticData.investmentSummary.avgExpectedRoi),
          avgEffectiveRoi: formatAsDecimal(statisticData.investmentSummary.avgEffectiveRoi),
          durationDays: formatAsDecimal(statisticData.investmentSummary.durationDays, {decimals: 0})
        };
      } else {
        this.investmentSummary = this.defaultInvestmentSummary
      }
    }
  }
};
</script>